<template>
  <PageContentLayoutOnly>
    <ModernTable
      :filters="filters"
      :rows="subscriptionNotifications"
      :columns="columns"
      :pagination="pagination"
    >
      <template v-slot:header>
        <div :style="{ padding: '0 0 8px' }">
          <b-button
            type="is-ghost"
            @click="toggleFilters"
            :style="styles.filterButton"
            :class="'filter-button ' + (filters.show ? 'active' : '')"
          >
            <b-icon pack="mdi" icon="filter-outline" size="is-small" style="display: inline-block">
            </b-icon>
            <div style="display: inline-block">Filter</div>
          </b-button>
        </div>
      </template>
    </ModernTable>

    <Modal :toggle.sync="toggle">
      <NotificationSubscriptionModal
        :toggle="toggle"
        :selectedSubscriptionNotification="selectedSubscriptionNotification"
      >
      </NotificationSubscriptionModal>
    </Modal>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ModernTable from '@/components/tables/Modern/Table'
import Modal from '@/components/Modal'
import NotificationSubscriptionModal from './components/NotificationSubscriptionModal'

import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'HoNotificationSubscriptions',
  components: {
    PageContentLayoutOnly,
    ModernTable,
    Modal,
    NotificationSubscriptionModal
  },

  data,

  computed: {
    ...mapGetters('alertSubscription', ['subscriptionNotificationList']),
    ...mapGetters('user', ['authUser']),
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {
    hoaId() {
      this.reload()
    },

    toggle() {
      if (this.toggle == false) {
        this.reload()
        this.toggle = false
        if (this.Modal && this.Modal != undefined) {
          this.Modal.$emit('update:toggle', (this.toggle = false))
        }
      }
    }
  },

  mounted() {
    this.reload()
  },

  methods,

  i18n: {
    messages: {
      en: { notificationSubscriptions: { title: 'Notification Subscriptions' } }
    }
  }
}
</script>
